import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { appInject } from 'src/app/app-injector';
import { PERCENT_MAX } from 'src/app/utils/number-constants';

import { loadingStatusIndicatorAnimation } from './loading-status-indicator.animation';
import { LoadingStatusIndicatorService } from './loading-status-indicator.service';

/**
 * Loading status indicator which shows up at the very bottom of the page as a slim blue loading bar.
 */
@Component({
  selector: 'cc-loading-status-indicator',
  templateUrl: './loading-status-indicator.component.html',
  styleUrl: './loading-status-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [loadingStatusIndicatorAnimation],
  imports: [LetDirective, NgClass, AsyncPipe]
})
export class LoadingStatusIndicatorComponent implements OnInit {
  public readonly isActive$ = this.loadingStatusIndicatorService.active$;

  public readonly transformStyle$ = combineLatest([this.isActive$, this.loadingStatusIndicatorService.progress$]).pipe(
    map(([isActive, progress]) => `translateX(${isActive ? progress * PERCENT_MAX - PERCENT_MAX : -PERCENT_MAX}%)`)
  );

  public constructor(
    private readonly loadingStatusIndicatorService: LoadingStatusIndicatorService,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    this.router.events.pipe(takeUntilDestroyed(appInject(DestroyRef))).subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loadingStatusIndicatorService.start('routing');
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationError ||
        event instanceof NavigationCancel
      ) {
        this.loadingStatusIndicatorService.finish('routing');
      }
    });
  }
}
